import React from 'react'

const Wasm = () => {
  return (
    <div>Wasm</div>
  )
}

export default Wasm